import Tree from "rc-tree";
import React, { useContext, useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import { INodeGeneric, contentTipology } from "../../app/models/node";
import "../../assets/scss/rc-tree/rc-tree.scss";
import "../../assets/scss/archive.scss";
import { EventDataNode } from "rc-tree/lib/interface";
import TreeElement from "../common/TreeElement";
import UserStore from "../../app/stores/userStore";
import { RootStore, RootStoreContext } from "../../app/stores/rootStore";
import TreeArchiveElement from "../common/TreeArchiveElement";
import { use } from "i18next";


const STYLE = `
.rc-tree-child-tree {
  display: block;
}
.node-motion {
  transition: all .3s;
  overflow-y: hidden;
}
`;

interface IParams {
    dataArray: INodeGeneric[];
    archiveId?: string;
    handleSelect?: (node: EventDataNode) => void;
    treeIconComponent: (nodeKey: string, hasDocument?: boolean, type?: contentTipology, hasChildren? : boolean, expandedByDefault?: boolean) => JSX.Element;
}

const getAllNodes = (dataArray: INodeGeneric[]) => {
  let tempExpanded = dataArray.map((n) => n.key);
  dataArray.forEach((n) => tempExpanded.push(...getAllNodes(n.children)));
  return tempExpanded;
};



const ArchiveTreeComponent: React.FC<IParams> = ({ dataArray,handleSelect,treeIconComponent,archiveId}) => {
  const rootStore = useContext(RootStoreContext);
  const {currentTenant} = rootStore.tenantStore;
  const { autoOpeningFolder } = rootStore.archiveStore;
    const ref = useRef<null | HTMLDivElement>(null);
    const notViewableTipology= [0 ,6 ,7]
  const [expanded, setExpanded] = useState<string[]>(getAllNodes(dataArray));
  const link = useRef<null | HTMLAnchorElement>(null);
  
  useEffect(() => {
    if(autoOpeningFolder !== undefined) {
      if(autoOpeningFolder === true) {
        setExpanded(getAllNodes(dataArray));
      }
      else {
        setExpanded([]);
      }
    }
  },[autoOpeningFolder, dataArray]);
  
  const handleActionDownload = (filename : string, href : string ) => {
    console.log("Download file: ", filename, " from: ", href);
    link.current!.download = filename;
    link.current!.href = href;
    link.current!.click();
  }



  const handleExpand = (node: EventDataNode) => {
    let key = node.key.toString();
    if(!node.isLeaf){
      let copy = [...expanded];
      if (copy.includes(key)){
        copy = copy.filter((x) => x !== key);
        document.getElementById(`containerIcon${node.key}`)!.className="fas fa-folder cursorPointer";
      } 
      else {
        copy.push(key);
        document.getElementById(`containerIcon${node.key}`)!.className="fas fa-folder-open cursorPointer";
      }
      setExpanded(copy);
    }
  };

  const formatNodes = (tree: INodeGeneric[] ) => {
    let retArray: any[] = [];
    tree.forEach((node) => {
      let childrenNodes = formatNodes(node.children);
      retArray.push({
        key: node.key,
        title: archiveId ? 
          node.type !== undefined && notViewableTipology.some(x => x === node.type) ? 
            // <TreeElement title={node.title}  className={(node.hasContent ? "" : "cursorNone" )+ " rc-tree-title-archive"} /> 
            <TreeArchiveElement
            handleActionDownload={handleActionDownload}
           contentId={node.contentId}
           archiveId={parseInt(archiveId)}
           className={(node.hasContent ? "" : "cursorNone" )+ " rc-tree-title-archive"}
            title={node.title}
            /> 
            :
            <TreeArchiveElement
            handleActionDownload={handleActionDownload}
           contentId={node.contentId}
           archiveId={parseInt(archiveId)}
            title={node.title} className={"rc-tree-title-archive"}
            link={`${currentTenant!.path}/archives/browse/${archiveId}/content/${node.contentId}`}
            /> 
        :
          <TreeElement title={node.title} className={"rc-tree-title-archive " + ((!node.hasContent && node.contentId < 0 ) ? "cursorNone" : "")} />,
        children: childrenNodes,
        // icon:  (<ArchiveTreeIcon isFolder={node.hasContent} type={node.type} />),
        icon:  treeIconComponent(node.key, node.hasContent, node.type, (node.contentId >= 1 ? undefined : node.contentId >= 0), autoOpeningFolder),
        isLeaf: !node.hasContent,
        selectable: (node.contentId >= 0 || node.hasContent),
        classNames: node.contentId + "&&&&" + node.type 
        // contentId: node.contentId,
        // tipology: node.type
      });
    });
    return retArray;
  };

  const doOnSelect = (node: EventDataNode) => {
    if(handleSelect)
      handleSelect(node)
    handleExpand(node);
  }

  return (
    <>
     <a role="button" href="/#" ref={link} style={{display: "none"}} > </a>
    <div className="draggable-demo odgTree"  ref={ref}>
      <style dangerouslySetInnerHTML={{ __html: STYLE }} />
      {dataArray && dataArray.length > 0 && (
        <Tree
        defaultExpandAll={autoOpeningFolder}
         expandedKeys={expanded}
          //onDragStart={this.onDragStart}
          //onDragEnter={this.onDragEnter}
        //   onDrop={(event) => handleDrop(event)}
          //onDrop={(a) => console.log("DRAGGED_NODE: ", a.dragNode.key, " --- DESTINATION_NODE: ", a.node.key, " --- POSITION: ", a.dropToGap)}
          treeData={formatNodes(dataArray)}
          onSelect={(selectedKeys, e) => doOnSelect(e.node)}
          showLine={true}
          onExpand={(selectedKeys, e) => {
            handleExpand(e.node);
          }}
          // onMouseLeave={(k) => setSelectedNode("")}
        />
      )}
    </div>
    </>
  );
};

export default observer(ArchiveTreeComponent);
